<template>
  <div class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section
          class="pa-4 pr-1 pb-0">
          <v-card 
            flat
            color="transparent">
            <v-card-text 
              class="px-0">
              <swiper 
                class="swiper"
                ref="swiper"
                :options="{ slidesPerView: 'auto' }">
                <swiper-slide 
                  v-for="(item, index) in menu" 
                  :key="index" 
                  style="max-width: 196px;">
                  <div
                    class="d-flex align-center justify-center">
                    <!-- <v-divider
                      :style="step >= item.value && index > 0 ? `border-bottom: 2px solid ${set_color};` : index > 0 ? 'border-bottom: 2px solid #00000020;' : 'border: 0px solid #FFFFFF;'" /> -->
                      
                    <v-btn
                      @click="goTo(item.value)"
                      width="125"
                      elevation="0"
                      class="body-2 font-weight-bold text-capitalize white--text pl-2 pr-3 d-flex align-center justify-start"
                      style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; border-radius: 10px;"
                      :color="step >= item.value ? `${set_color}` : '#00000020'">
                      <v-avatar
                        size="24"
                        tile
                        color="#0000001a"
                        style="border-radius: 5px !important;">
                        {{ item.value }}
                      </v-avatar>
                      
                      <span
                        class="ml-2">
                        {{ item.title }}
                      </span>
                    </v-btn>

                    <v-divider
                      :style="step > item.value && index < menu.length - 1 ? `border-bottom: 2px solid ${set_color};` : index < menu.length - 1 ? 'border-bottom: 2px solid #00000020;' : 'border: 0px solid #FFFFFF;'" />
                  </div>
                </swiper-slide>
              </swiper>

              <v-card
                class="mt-8"
                min-height="calc(100vh - 353px)"
                style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; border-radius: 10px;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">

                    <Biodata v-if="step === 1"
                      :form="form"
                      @load="fetch()"
                      @step="step = $event; toSlide($event);" />

                    <Personal v-if="step === 2"
                      :form="form"
                      @load="fetch()"
                      @step="step = $event; toSlide($event);" />

                    <Kawedanan v-if="step === 3"
                      :form="form"
                      @load="fetch()"
                      @step="step = $event; toSlide($event);" />

                    <Kalenggahan v-if="step === 4"
                      :form="form"
                      @load="fetch()"
                      @step="step = $event; toSlide($event);" />

                    <Kontak v-if="step === 5"
                      :form="form"
                      @load="fetch()"
                      @step="step = $event; toSlide($event);" />

                    <Keluarga v-if="step === 6"
                      :form="form"
                      @load="fetch()"
                      @step="step = $event; toSlide($event);" />

                    <Urusan v-if="step === 7"
                      :form="form"
                      @load="fetch()"
                      @step="step = $event; toSlide($event);" />

                    <Pakaian v-if="step === 8"
                      :form="form"
                      @load="fetch()"
                      @step="step = $event; toSlide($event);" />
                    
                    <!-- <Riwayat v-if="step === 8"
                      :form="form"
                      @load="fetch()"
                      @step="step = $event; toSlide($event);" /> -->

                    <Lainnya v-if="step === 9"
                      :form="form"
                      @load="fetch()"
                      @step="step = $event; toSlide($event);" />

                  </ValidationObserver>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        step: 1,
        menu: [
          {
            title: 'Biodata',
            value: 1
          },
          {
            title: 'Personal',
            value: 2
          },
          {
            title: 'Kawedanan',
            value: 3
          },
          {
            title: 'Kalenggahan',
            value: 4
          },
          {
            title: 'Kontak',
            value: 5
          },
          {
            title: 'Keluarga',
            value: 6
          },
          {
            title: 'Urusan',
            value: 7
          },
          {
            title: 'Pakaian',
            value: 8
          },
          // {
          //   title: 'Kesehatan',
          //   value: 8
          // },
          {
            title: 'Lainnya',
            value: 9
          }
        ],
        form: {
          id: '',
          // BIODATA
          image_url: '',
          code: '',
          name: '',
          role: '',
          kalenggahan: '',
          kalenggahan_name: '',
          urusan: '',
          category: '',
          status: '',
          join_date: '',
          trah_id: '',
          trah_status_id: '',
          
          // unit: [],
          unit: '',
          seksi: [],
          seksi_string: '',

          // PERSONAL
          nik: '',
          nik_url: '',
          kk: '',
          kk_url: '',
          birthplace: '',
          birthdate: '',
          gender: '',
          ktp_address: '',
          domicile_address: '',
          religion: '',
          blood_group: '',
          last_education: '',
          degree_education: '',
          profession: '',
          mobilephone: '',
          wa_number: '',
          email: '',
          marital_status: '',

          // PAKAIAN
          ukuran_kaos: '',
          ukuran_blangkon: '',
          ukuran_selop: '',
          ukuran_pranakan: '',
          ukuran_atela: '',

          // LAINNYA
          norek_danais: '',
          tgl_awal_terima_danais: '',
          kop_join_date: '',
          bpjs_jenis: '',
          job_other: '',

          npwp: '',
          emergency_number: '',
          emergency_number_name: '',

          asuransi_kes: '',
          nomor_polis_asuransi: '',
          asuransi_status: '',
          catatan_kesehatan: '',

          // EXTRA
          lama_mengabdi: 'Belum diketahui',
          age: 'Belum diketahui',

          is_active: 'Aktif'
        },
        process: {
          load: false
        }
      }
    },
    components: {
      Biodata: () => import(/* webpackPrefetch: true */ '@/components/form/sentana/biodata.vue'),
      Personal: () => import(/* webpackPrefetch: true */ '@/components/form/sentana/personal.vue'),
      Kawedanan: () => import(/* webpackPrefetch: true */ '@/components/form/sentana/kawedanan.vue'),
      Kalenggahan: () => import(/* webpackPrefetch: true */ '@/components/form/sentana/kalenggahan.vue'),
      Kontak: () => import(/* webpackPrefetch: true */ '@/components/form/sentana/kontak.vue'),
      Keluarga: () => import(/* webpackPrefetch: true */ '@/components/form/sentana/keluarga.vue'),
      Urusan: () => import(/* webpackPrefetch: true */ '@/components/form/sentana/urusan.vue'),
      Pakaian: () => import(/* webpackPrefetch: true */ '@/components/form/sentana/pakaian.vue'),
      Riwayat: () => import(/* webpackPrefetch: true */ '@/components/form/sentana/riwayat.vue'),
      Lainnya: () => import(/* webpackPrefetch: true */ '@/components/form/sentana/lainnya.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      }
    },
    mounted () {
      this.step = this.$route.query.step === undefined ? 1 : parseInt(this.$route.query.step)

      this.fetch()
    },
    methods: {
      async goTo (val) {
        let step_from = this.$route.query.step

        if (step_from == 1 || step_from == 2 || step_from == 5 || step_from == 8 || step_from == 9) {
          const isValid = await this.$refs.form.validate()

          if (isValid) {
            let forms = Object.assign({}, this.form)
            forms.seksi = JSON.stringify(forms.seksi)
            forms.mobilephone =  this.form.mobilephone !== '' && this.form.mobilephone !== null ? `62${this.form.mobilephone}` : this.form.mobilephone
            forms.wa_number =  this.form.wa_number !== '' && this.form.wa_number !== null ? `62${this.form.wa_number}` : this.form.wa_number
            forms.emergency_number =  this.form.emergency_number !== '' && this.form.emergency_number !== null ? `62${this.form.emergency_number}` : this.form.emergency_number

            await post(`admin/user/update`, {
              data: forms
            })
            .then((response) => {
              let res = response.data

              if (res.status === 200 ) {
                this.step = val

                this.$emit('step', val)
                this.$router.push({ path: `/sentana/form/edit/${this.$route.params.id}`, query: { step: val }})
              }
            })
          }
        } else {
          this.step = val

          this.$router.push({ path: `/sentana/form/edit/${this.$route.params.id}`, query: { step: val }})
        }
      },
      
      async fetch () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get(`admin/user/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            let item = res.results.data

            this.form = {
              id: item.id,
              // BIODATA
              image_url: item.image_url,
              code: item.code,
              name: item.name,
              role: item.role,
              kalenggahan: item.kalenggahan,
              kalenggahan_name: item.kalenggahan_name,
              urusan: item.urusan,
              category: item.category,
              status: item.status,
              join_date: item.join_date,
              trah_id: item.trah_id,
              trah_status_id: item.trah_status_id,
              
              
              // unit: [],
              unit: item.kawedanan === undefined ? '' : item.kawedanan[0].id,
              seksi: [],
              seksi_string: '',

              // PERSONAL
              nik: item.nik,
              nik_url: item.nik_url,
              kk: item.kk,
              kk_url: item.kk_url,
              birthplace: item.birthplace,
              birthdate: item.birthdate,
              gender: item.gender,
              ktp_address: item.ktp_address,
              domicile_address: item.domicile_address,
              religion: item.religion,
              blood_group: item.blood_group,
              last_education: item.last_education,
              degree_education: item.degree_education,
              profession: item.profession,
              mobilephone: item.mobilephone.replace(/^0/, '').replace(/^62/, ''),
              wa_number: item.wa_number.replace(/^0/, '').replace(/^62/, ''),
              email: item.email,
              marital_status: item.marital_status,

              // PAKAIAN
              ukuran_kaos: item.ukuran_kaos,
              ukuran_blangkon: item.ukuran_blangkon,
              ukuran_selop: item.ukuran_selop,
              ukuran_pranakan: item.ukuran_pranakan,
              ukuran_atela: item.ukuran_atela,

              // LAINNYA
              norek_danais: item.norek_danais,
              tgl_awal_terima_danais: item.tgl_awal_terima_danais,
              kop_join_date: item.kop_join_date,
              bpjs_jenis: item.bpjs_jenis,
              job_other: item.job_other,

              npwp: item.npwp,
              emergency_number: item.emergency_number.replace(/^0/, '').replace(/^62/, ''),
              emergency_number_name: item.emergency_number_name,

              asuransi_kes: item.asuransi_kes,
              nomor_polis_asuransi: item.nomor_polis_asuransi,
              asuransi_status: item.asuransi_status,
              catatan_kesehatan: item.catatan_kesehatan,

              // EXTRA
              lama_mengabdi: item.lama_mengabdi === undefined ? 'Belum diketahui' : item.lama_mengabdi,
              age: item.age === undefined ? 'Belum diketahui' : item.age,

              is_active: item.is_active
            }

            // if (item.kawedanan !== undefined && item.kawedanan.length > 0) {
            //   item.kawedanan.map(obj => {
            //     this.form.unit.push(obj.id)
            //   })
            // }

            if (item.seksi !== undefined && item.seksi.length > 0) {
              item.seksi.map(obj => {
                this.form.seksi.push(obj.id)
              })

              this.form.seksi_string = item.seksi[0].id
            }
          }
        })
      },

      // SLIDE
      toSlide (step) {
        this.$refs.swiper.$swiper.slideTo(step - 1, 500, false)
      }
    }
  }
</script>